<script setup lang="ts">
import { affiliateConfigs } from '~/utils/perfilOficialConfigs';

const padrinhoConfig = affiliateConfigs.padrinho;
</script>

<template>
  <AfiliadoGamesPage :config="padrinhoConfig" />
</template>
